import { Dispatch } from "react";
import { createSlice, PayloadAction, AnyAction } from "@reduxjs/toolkit";
import * as firebase from "firebase/app";
import { UserProfile, fetchUserProfile } from "./api";

export interface AppState {
  loading: boolean;
  error: boolean;
  profile: UserProfile | null;
  user_info: firebase.UserInfo | null;
  feature_flags: FeatureFlags | null;
  app_info: AppInfo | null;
}

type AvailableZakat = "fitrah" | "harta" | "padi";

interface FeatureFlags {
  debug: boolean;
  dashboard: boolean;
  user_type: "amil" | "admin";
  zakat: AvailableZakat[];
}

interface AppInfo {
  name: string;
  icon: string;
}

const initialState = (): AppState => {
  return {
    loading: false,
    error: false,
    profile: null,
    user_info: null,
    feature_flags: null,
    app_info: null
  };
};

const appStateSlice = createSlice({
  name: "appState",
  initialState: initialState(),
  reducers: {
    loading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    hasError(state) {
      state.error = true;
      state.loading = false;
    },
    setUserProfile(state, action: PayloadAction<UserProfile | null>) {
      state.profile = action.payload;
    },
    setUserInfo(state, action: PayloadAction<firebase.UserInfo>) {
      state.user_info = action.payload;
    }
  }
});

export const {
  loading,
  hasError,
  setUserInfo,
  setUserProfile
} = appStateSlice.actions;

export const updateUserInfo = (info: firebase.UserInfo) => (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch(setUserInfo(info));
};

export const doSessionLogin = (token: string) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch(loading(true));
  dispatch(setUserProfile(null));
  try {
    const profile = await fetchUserProfile(token);
    dispatch(setUserProfile(profile));
  } catch (e) {
    dispatch(hasError());
  } finally {
    dispatch(loading(false));
  }
};

export default appStateSlice.reducer;
